import { useMfaProgress } from '../hooks/useMfaProgress';

const fmtWhen = (iso) =>
  iso
    ? new Date(iso).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })
    : '';

function Row({ color, label, value, total }) {
  const pct = total ? Math.round((value / total) * 100) : 0;
  return (
    <div className="flex items-center gap-3 py-1.5">
      <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${color}`} />
      <span className="flex-1 text-sm text-gray-700">{label}</span>
      <span className="text-sm font-semibold tabular-nums text-gray-900">{value}</span>
      <span className="w-10 text-right text-xs tabular-nums text-gray-400">{pct}%</span>
    </div>
  );
}

function MfaProgressCard() {
  const { data, isLoading, isError } = useMfaProgress();
  const pct = data && data.total ? Math.round((data.appOnly / data.total) * 100) : 0;
  return (
    <div className="w-full max-w-md rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
      <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500">MFA — Authenticator-only progress</h2>
      <p className="mb-4 mt-0.5 text-xs text-gray-400">Goal: Authenticator app only, SMS removed.</p>
      {isLoading && <p className="text-sm text-gray-400">Loading…</p>}
      {isError && <p className="text-sm text-red-500">Couldn’t load MFA data.</p>}
      {data && (
        <>
          <div className="mb-1 flex items-end gap-2">
            <span className="text-3xl font-bold text-brand">{pct}%</span>
            <span className="mb-1 text-sm text-gray-500">
              {data.appOnly} of {data.total} fully on Authenticator
            </span>
          </div>
          <div className="mb-4 h-2 w-full overflow-hidden rounded-full bg-gray-100">
            <div className="h-full rounded-full bg-emerald-500" style={{ width: `${pct}%` }} />
          </div>
          <div className="divide-y divide-gray-100">
            <Row color="bg-emerald-500" label="Authenticator only — done" value={data.appOnly} total={data.total} />
            <Row color="bg-amber-400" label="Has app, SMS still on — remove SMS" value={data.both} total={data.total} />
            <Row color="bg-red-400" label="SMS only — no Authenticator yet" value={data.smsOnly} total={data.total} />
            <Row color="bg-gray-300" label="No MFA method" value={data.none} total={data.total} />
          </div>
          <p className="mt-3 text-[11px] text-gray-400">
            {data.authenticatorRegistered} have the app · {data.smsRegistered} still have SMS · as of{' '}
            {fmtWhen(data.generatedAt)}
          </p>
        </>
      )}
    </div>
  );
}

export default MfaProgressCard;
